import { render, staticRenderFns } from "./CtcSimilarGroupsEditor.vue?vue&type=template&id=1cedd70a&scoped=true&"
import script from "./CtcSimilarGroupsEditor.vue?vue&type=script&lang=js&"
export * from "./CtcSimilarGroupsEditor.vue?vue&type=script&lang=js&"
import style0 from "./CtcSimilarGroupsEditor.vue?vue&type=style&index=0&id=1cedd70a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cedd70a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
